import React from 'react';
import { motion } from 'framer-motion';
import { ConsentState, getConsentStateColor } from '../../constants/uaeStandards';
import { CheckCircle2Icon, ClockIcon, PauseIcon, XCircleIcon, AlertTriangleIcon, BanIcon } from 'lucide-react';
interface ConsentStateBadgeProps {
  state: ConsentState;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}
export function ConsentStateBadge({
  state,
  size = 'md',
  showIcon = true
}: ConsentStateBadgeProps) {
  const colors = getConsentStateColor(state);
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };
  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };
  const getIcon = () => {
    switch (state) {
      case 'Authorized':
        return <CheckCircle2Icon className={iconSizes[size]} data-id="element-1620" />;
      case 'Awaiting':
        return <ClockIcon className={iconSizes[size]} data-id="element-1621" />;
      case 'Paused':
        return <PauseIcon className={iconSizes[size]} data-id="element-1622" />;
      case 'Suspended':
        return <AlertTriangleIcon className={iconSizes[size]} data-id="element-1623" />;
      case 'Canceled':
      case 'Rejected':
        return <XCircleIcon className={iconSizes[size]} data-id="element-1624" />;
      case 'Consumed':
      case 'Expired':
        return <BanIcon className={iconSizes[size]} data-id="element-1625" />;
      default:
        return null;
    }
  };
  return <motion.div initial={{
    scale: 0.9,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    duration: 0.2
  }} className={`inline-flex items-center gap-1.5 font-semibold rounded-full ${sizeClasses[size]}`} style={{
    backgroundColor: colors.bg,
    color: colors.text,
    border: `1.5px solid ${colors.border}`
  }} data-id="element-1626">
      {showIcon && getIcon()}
      <span data-id="element-1627">{state}</span>
    </motion.div>;
}